export function setUser(user) {
  localStorage.setItem('current-user', JSON.stringify(user));
}

export function getUser() {
  const userStr = localStorage.getItem('current-user');
  const user = userStr ? JSON.parse(userStr) || {} : {};
  return user;
}

import { getToken as getTokenFromMemory } from '@/utils/token';

// 从 memoryToken 中获取 token（返回字符串，用于简单判断）
// 注意：为了兼容旧代码，这里返回 access_token 字符串，而不是对象
export function getToken() {
  const token = getTokenFromMemory();
  return token?.access_token || null;
}

// 从 memoryToken 中获取完整的 token 信息（返回对象，用于请求头）
export function getTokenInfo() {
  return getTokenFromMemory();
}

export function getAuthorityByToken() {
  // 权限判定只依赖用户信息，不依赖 token
  // 因为：
  // 1. 用户信息存储在 localStorage 中（持久化）
  // 2. Token 存储在 model 中（内存）
  // 3. 菜单权限应该基于用户信息，而不是 token
  // 4. Token 的验证在 CheckPermissions 和 request 拦截器中进行

  const user = getUser();
  if (!user || !user.permissions) {
    return [];
  }
  return user.permissions;
}

export function getAuthority() {
  return getAuthorityByToken();
}
